// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","headerContent":"header_headerContent__3hc8s","logoImg":"header_logoImg__2AFb5","btnLink":"header_btnLink__25iVr"};